import { useUrl } from '@/hooks/routes';
export const useHandleLoginOrSignUpProps = () => {
  const url = useUrl()
  const urlOrigin = url.origin

  const handleLoginOrSignUpProps = (origin_url: string) => {
    if (!origin_url) {
      return {
        origin_url,
      }
    }
    try {
      const origin_host = new URL(origin_url, urlOrigin).host
      const origin_path = new URL(origin_url, urlOrigin).pathname
      return {
        origin_url,
        origin_host,
        origin_path,
      }
    } catch (error) {
      return {
        origin_url,
      }
    }
  }
  return {
    handleLoginOrSignUpProps,
  }
}
